<script setup lang="ts">
const { menuItems } = useMenuItems()
</script>

<template>
  <div class="HeaderMenu">
    <div class="HeaderMenu_Container">
      <nav aria-label="Catalog" class="HeaderMenu_Nav">
        <ul v-if="menuItems" class="HeaderMenu_List">
          <HeaderMenuListItem
            v-for="menuItem in menuItems"
            :key="menuItem.id"
            class="HeaderMenu_ListItem"
            v-bind="menuItem"
          />
        </ul>
      </nav>
      <SearchBarAutocomplete class="HeaderMenu_Search" />
    </div>
  </div>
</template>

<style lang="scss">
.HeaderMenu {
  @include container-large;
  background-color: var(--surface-color-default);
  border-bottom: solid 1px var(--border-color-default);
  position: relative;

  @include for-large-up {
    --container-margin: var(--spacing-8x);
  }

  &_Container {
    display: grid;
    grid-template-columns: auto 25%;
    gap: var(--spacing-3x);
  }

  &_Nav {
    overflow-x: hidden;
  }

  &_List {
    display: flex;
    margin: 0;
    height: 100%;
    padding-inline-start: 0;
  }

  &_ListItem {
    * > :last-child {
      margin: 0 var(--spacing-1x);
    }
  }

  &_Search {
    margin: var(--spacing-1x) 0;
  }
}
</style>
